var Backbone,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Modules.EmailSubscription.Helpers.Sessions = require('../helpers/sessions');

Backbone = require('backbone');

Backbone.$ = $;

Modules.EmailSubscription.Views.MerchantAlerts = (function(superClass) {
  extend(MerchantAlerts, superClass);

  function MerchantAlerts() {
    return MerchantAlerts.__super__.constructor.apply(this, arguments);
  }

  MerchantAlerts.prototype.events = {
    "click .subscribe-merchant-submit": "_merchantSubmitSubscription"
  };

  MerchantAlerts.prototype.initialize = function() {
    this.model.url = this.$el.data("endpoint");
    this.$errorMessage = this.$el.find('.error-message');
    this.listenTo(this.model, 'subscribe:success', this._showSubscribedMessage);
    return this.listenTo(this.model, 'subscribe:error', this.onFetchError);
  };

  MerchantAlerts.prototype._merchantSubmitSubscription = function(event) {
    var email, slug, targetElement;
    if (event != null) {
      event.preventDefault();
    }
    targetElement = $(event.currentTarget) ? $(event.currentTarget) : $(event.srcElement);
    email = email || this._trimText(targetElement.siblings('.subscribe-email').val());
    slug = $('.coupon-email-alert').attr('data-merchant-slug') || $('#couponModal').attr('data-merchant-slug');
    if (!((email != null) && email.length > 0)) {
      return false;
    }
    this.$errorMessage.addClass('hide');
    this.model.fetch({
      data: {
        slug: slug,
        email: email,
        subscriber_type: "merchant_channel",
        _csrf: Groupon.Shared.csrfToken
      },
      type: 'POST',
      error: _.bind(this.onFetchError, this)
    });
    return false;
  };

  MerchantAlerts.prototype._showSubscribedMessage = function() {
    this.$el.find('.subscribe-merchant-submit').val(I18n.t('js.modules.email_subscription.subscribed_message'));
    this.$el.find('.subscribe-merchant-submit').addClass('btn-cta');
    return this.$el.find('.subscribe-merchant-submit').prop('disabled', true);
  };

  MerchantAlerts.prototype.onFetchError = function(error) {
    switch (error != null ? error.code : void 0) {
      case 'unable-to-create-subscription':
        return this._showError(I18n.t('js.modules.email_subscription.errors.unable_to_create'));
      default:
        return this._showError(I18n.t('js.modules.email_subscription.errors.unexpected'));
    }
  };

  MerchantAlerts.prototype._showError = function(message) {
    this.$errorMessage.text(message);
    return this.$errorMessage.removeClass('hide');
  };

  MerchantAlerts.prototype._trimText = function(text) {
    return text.replace(/^\s+|\s+$/g, '');
  };

  return MerchantAlerts;

})(Backbone.View);

module.exports = Modules.EmailSubscription.Views.MerchantAlerts;

